import React from 'react'
import { Helmet } from 'react-helmet'

import { useStyles } from '../Lost_style'
import { Box } from '@material-ui/core'

import Oops from '../components/Oops/Oops'
import LostRecommendedArticles from '../components/LostRecommendedArticles/LostRecommendedArticles'
import LostRecommendedJobs from '../components/LostRecommendedJobs/LostRecommendedJobs'
import URLHandler from 'assets/URLHandler.js'

const LostJobPage = (props) => {
    const { user } = props
    const jobType = URLHandler.getJobTypeFromUrl()
    const classes = useStyles()

    return (<>
        <Helmet>
            <meta name='robots' content='noindex' />
            <meta name='googlebot' content='noindex' />
        </Helmet>
        <Oops subtitleId='transl_jobs.does_not_exist_banner' />
        <Box className={classes.similarJobsBox}>
            <LostRecommendedJobs user={user} job={{ type: jobType }} />
        </Box>
        <Box className={classes.similarArticlesBox}>
            <LostRecommendedArticles
                user={user}
                category={jobType}
                titleId='transl_internship.job_show.card_slider.title'
                moreItemsId={`job_show_similar_items.see_more_articles.${jobType || 'all'}`}
            />
        </Box>
    </>)
}

export default LostJobPage
